import { logErrorToSlack, logInfoToSlack } from './logToSlack.js';

// Logger utility function that will:
// 1. make it easier to hook up external log/error tracking to the app
// 2. Add the ability to filter logs by category, reducing noise in the console
// Global catalogId store
let globalCatalogId = '';
const enabledLogs = {
    analytics: true,
    api: true,
};
const showLog = (category) => {
    if ((category === 'analytics' && !enabledLogs.analytics) ||
        (category === 'api' && !enabledLogs.api)) {
        return false;
    }
    return true;
};
// Set the global catalogId for the application
const setCatalogId = (catalogId) => {
    globalCatalogId = catalogId;
    // Also store in localStorage as a fallback
    try {
        if (typeof window !== 'undefined') {
            window.localStorage.setItem('hah_catalog_id', catalogId);
        }
    }
    catch (e) {
        // Ignore localStorage errors (e.g., in incognito mode)
    }
};
// Get the current global catalogId, with fallbacks
const getCatalogId = () => {
    // First try the global variable
    if (globalCatalogId) {
        return globalCatalogId;
    }
    // Then try localStorage
    try {
        if (typeof window !== 'undefined') {
            const storedCatalogId = window.localStorage.getItem('hah_catalog_id');
            if (storedCatalogId) {
                // If found in localStorage, also set the global var for future use
                globalCatalogId = storedCatalogId;
                return storedCatalogId;
            }
        }
    }
    catch (e) {
        // Ignore localStorage errors
    }
    return '';
};
const logger = (message, props = {}) => {
    const prependText = props.preText || '';
    // Use provided catalogId or fall back to the global/stored one
    const catalogId = getCatalogId();
    const url = typeof window !== 'undefined' ? window.location.href : '';
    if (showLog(props.category) || props.sendLog) {
        if (props.type === 'error') {
            if (!props.skipConsole) {
                // eslint-disable-next-line no-console
                console.error(prependText, message);
            }
            logErrorToSlack({
                log: `${catalogId} - ${url} - ${message}`,
                method: 'logger',
            });
        }
        if (props.type === 'log') {
            if (!props.skipConsole) {
                // eslint-disable-next-line no-console
                console.log(prependText, message);
            }
            logInfoToSlack({
                log: `${catalogId} - ${url} - ${message}`,
                method: 'logger',
            });
        }
    }
};

export { logger as default, getCatalogId, setCatalogId };
//# sourceMappingURL=logger.js.map
